import React, { useState } from "react";

import { auth } from "../../Firebase/firebase";
import classes from "./SendMessage.module.css";

const SendMessage = (props) => {
    const [message, setMessage] = useState('');

    const formSubmitHandler = event => {
        event.preventDefault();
        props.runCleanerHandler()
        let token = localStorage.getItem('idToken'),
            senderId = localStorage.getItem('uid');
        if (!token) {
            const fireUser = auth.currentUser
            if (fireUser) {
                fireUser.getIdToken(true)
                    .then(responseToken => {
                        console.log(responseToken)
                        token = responseToken
                    })
                    .catch(error => console.log(error))
            }
            else {
                console.log(fireUser)
            }
        }

        if (!(message.trim() === '')) {
            props.sendMessage(token, message, props.reciverId, senderId, props.chatId, props.recvierToken);
            props.showNewCreatedMessageHandler(message)

        }

        setMessage('')
    };

    const onChangeHandler = (event) => {
        setMessage(event.target.value)
    };

    return (
        <form className={classes.SendMessage}
            onSubmit={(event) => formSubmitHandler(event)}>
            <input type='text' autoFocus={true} value={message} onChange={(event) => onChangeHandler(event)} />
            <button>send</button>
        </form>
    );
};

export default SendMessage;